__turbopack_context__.v({
  "canvasBox": "GlobeIndicator-module__E9WeTW__canvasBox",
  "caption": "GlobeIndicator-module__E9WeTW__caption",
  "fill": "GlobeIndicator-module__E9WeTW__fill",
  "globe-fade-in": "GlobeIndicator-module__E9WeTW__globe-fade-in",
  "wrap": "GlobeIndicator-module__E9WeTW__wrap",
});
